import { AnimatePresence, motion } from 'framer-motion';
import type { BackgroundType, SceneBackground } from '@/types';

import forest from '@/assets/images/backgrounds/placeholder-forest.svg';
import village from '@/assets/images/backgrounds/placeholder-village.svg';
import fire from '@/assets/images/backgrounds/placeholder-fire.svg';
import cave from '@/assets/images/backgrounds/placeholder-cave.svg';
import mystical from '@/assets/images/backgrounds/placeholder-mystical.svg';
import ruins from '@/assets/images/backgrounds/placeholder-ruins.svg';
import river from '@/assets/images/backgrounds/placeholder-river.svg';
import cliffs from '@/assets/images/backgrounds/placeholder-cliffs.svg';

const MAPA: Record<BackgroundType, string> = {
  forest,
  village,
  fire,
  cave,
  mystical,
  ruins,
  river,
  cliffs,
  custom: ruins,
};

interface Props {
  background: SceneBackground;
  /** Clave única por escena para que el crossfade dispare. */
  sceneKey: string;
}

export function SceneBackgroundLayer({ background, sceneKey }: Props) {
  const src = background.image ?? MAPA[background.type];

  return (
    <div className="absolute inset-0 overflow-hidden" aria-hidden>
      <AnimatePresence mode="sync">
        <motion.div
          key={sceneKey}
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${src})` }}
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 0.55, scale: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1.4, ease: 'easeOut' }}
        />
      </AnimatePresence>
      <div className="absolute inset-0 bg-gradient-to-t from-ash-950 via-ash-950/50 to-transparent" />
      <div className="absolute inset-0 bg-vignette" />
    </div>
  );
}
